import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, take } from 'rxjs';
import { ProformViewStates } from '../../../dtos/proforms.dto';
import { ProformsSubmissionService } from '../../../services/proforms/proforms-submission.service';
import {
  ProformFieldTypes,
  ProFormsQuestionAPIResponse,
} from '../../../types/responses/proforms.responses';

@Component({
  selector: 'app-proforms-question-answer-text',
  standalone: false,
  templateUrl: './proforms-question-answer-text.component.html',
  styleUrl: './proforms-question-answer-text.component.scss',
})
export class ProformsQuestionAnswerTextComponent implements OnInit {
  @Input() question: ProFormsQuestionAPIResponse;

  @Input() viewState: ProformViewStates = ProformViewStates.PREVIEW;

  FieldTypes = ProformFieldTypes;

  viewStates = ProformViewStates;

  textControl: FormControl;

  textareaControl: FormControl;

  debounceTime = 500;

  constructor(private proformsSubmissionService: ProformsSubmissionService) {}

  ngOnInit(): void {
    this.textControl = new FormControl({
      value: '',
      disabled:
        this.viewState === this.viewStates.SUBMITTED ||
        this.viewState === this.viewStates.GRADED,
    });

    this.textareaControl = new FormControl({
      value: '',
      disabled:
        this.viewState === this.viewStates.SUBMITTED ||
        this.viewState === this.viewStates.GRADED,
    });

    if (this.question) {
      if (
        this.viewState === this.viewStates.SUBMITTED ||
        this.viewState === this.viewStates.GRADED
      ) {
        this.proformsSubmissionService.currentSubmission.subscribe(
          (submission) => {
            if (submission) {
              if (submission.answers) {
                const answer = submission.answers.find(
                  (a) => a.proform_form_question_id === this.question.id
                );
                if (answer) {
                  this.setValue(answer.text_answer);
                }
              }
            }
          }
        );
      } else if (this.viewState === this.viewStates.EDIT) {
        // Load in form values from local storage if there are any
        this.proformsSubmissionService.newSubmission
          .pipe(take(1))
          .subscribe((submission) => {
            if (submission) {
              if (submission.answers) {
                const answer = submission.answers.find(
                  (a) => a.proform_form_question_id === this.question.id
                );
                if (answer?.text_answer) {
                  this.setValue(answer.text_answer);
                }
              }
            }
          });
        // Listeners for updating payload values
        if (this.question.field_type === this.FieldTypes.TEXT) {
          this.textControl.valueChanges
            .pipe(debounceTime(this.debounceTime))
            .subscribe((value) => {
              this.proformsSubmissionService.addAnswerToPayload(
                {
                  proform_form_question_id: this.question.id,
                  text_answer: value,
                },
                this.question.field_type
              );
            });
        } else {
          this.textareaControl.valueChanges
            .pipe(debounceTime(this.debounceTime))
            .subscribe((value) => {
              this.proformsSubmissionService.addAnswerToPayload(
                {
                  proform_form_question_id: this.question.id,
                  text_answer: value,
                },
                this.question.field_type
              );
            });
        }
      }
    }
  }

  setValue(answer: string): void {
    if (this.question.field_type === this.FieldTypes.TEXT) {
      this.textControl.setValue(answer, { emitEvent: false });
    } else {
      this.textareaControl.setValue(answer, { emitEvent: false });
    }
  }
}
